/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "kuesê",
        "-2": "amũ kuesê",
        "0": "wií",
        "1": "wirãdé",
        "2": "wirãdé ariré",
        "future": {
          "one": "{0} ara resê",
          "other": "{0} ara itá resê"
        },
        "past": {
          "one": "aikué {0} ara",
          "other": "aikué {0} ara itá"
        }
      },
      "day-narrow": {
        "-1": "kuesê",
        "-2": "amũ kuesê",
        "0": "wií",
        "1": "wirãdé",
        "2": "wirãdé ariré",
        "future": {
          "one": "{0} ara resê",
          "other": "{0} ara itá resê"
        },
        "past": {
          "one": "aikué {0} ara",
          "other": "aikué {0} ara itá"
        }
      },
      "day-short": {
        "-1": "kuesê",
        "-2": "amũ kuesê",
        "0": "wií",
        "1": "wirãdé",
        "2": "wirãdé ariré",
        "future": {
          "one": "{0} ara resê",
          "other": "{0} ara itá resê"
        },
        "past": {
          "one": "aikué {0} ara",
          "other": "aikué {0} ara itá"
        }
      },
      "hour": {
        "0": "kuá hura",
        "future": {
          "one": "{0} hura resê",
          "other": "{0} hura resê itá"
        },
        "past": {
          "one": "aikué {0} hura",
          "other": "aikué {0} hura itá"
        }
      },
      "hour-narrow": {
        "0": "kuá hura",
        "future": {
          "one": "{0} h resê",
          "other": "{0} h resê itá"
        },
        "past": {
          "one": "aikué {0} h",
          "other": "aikué {0} h itá"
        }
      },
      "hour-short": {
        "0": "kuá hura",
        "future": {
          "one": "{0} h resê",
          "other": "{0} h resê itá"
        },
        "past": {
          "one": "aikué {0} h",
          "other": "aikué {0} h itá"
        }
      },
      "minute": {
        "0": "kuá minutu",
        "future": {
          "one": "{0} minutu resê",
          "other": "{0} minutu resê itá"
        },
        "past": {
          "one": "aikué {0} minutu",
          "other": "aikué {0} minutu itá"
        }
      },
      "minute-narrow": {
        "0": "kuá minutu",
        "future": {
          "one": "{0} min. resê",
          "other": "{0} min. resê itá"
        },
        "past": {
          "one": "aikué {0} min.",
          "other": "aikué {0} min. itá"
        }
      },
      "minute-short": {
        "0": "kuá minutu",
        "future": {
          "one": "{0} min. resê",
          "other": "{0} min. resê itá"
        },
        "past": {
          "one": "aikué {0} min.",
          "other": "aikué {0} min. itá"
        }
      },
      "month": {
        "-1": "yasí kuera",
        "0": "kuá yasí",
        "1": "amũ yasí",
        "future": {
          "one": "{0} yasí resê",
          "other": "{0} yasí itá resê"
        },
        "past": {
          "one": "aikué {0} yasí",
          "other": "aikué {0} yasí itá"
        }
      },
      "month-narrow": {
        "-1": "yasí kuera",
        "0": "kuá yasí",
        "1": "amũ yasí",
        "future": {
          "one": "{0} yasí resê",
          "other": "{0} yasí itá resê"
        },
        "past": {
          "one": "aikué {0} yasí",
          "other": "aikué {0} yasí itá"
        }
      },
      "month-short": {
        "-1": "yasí kuera",
        "0": "kuá yasí",
        "1": "amũ yasí",
        "future": {
          "one": "{0} yasí resê",
          "other": "{0} yasí itá resê"
        },
        "past": {
          "one": "aikué {0} yasí",
          "other": "aikué {0} yasí itá"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "kasakiriwara musapíri-yasí",
        "0": "kuá musapíri-yasí",
        "1": "amũ musapíri-yasí",
        "future": {
          "one": "{0} musapíri-yasí resê",
          "other": "{0} musapíri-yasí itá resê"
        },
        "past": {
          "one": "aikué {0} musapíri-yasí",
          "other": "aikué {0} musapíri-yasí itá"
        }
      },
      "quarter-narrow": {
        "-1": "kasakiriwara musapíri-yasí",
        "0": "kuá musapíri-yasí",
        "1": "amũ musapíri-yasí",
        "future": {
          "one": "{0} mu-y. resê",
          "other": "{0} mu-y. itá resê"
        },
        "past": {
          "one": "aikué {0} mu-y.",
          "other": "aikué {0} mu-y. itá"
        }
      },
      "quarter-short": {
        "-1": "kasakiriwara musapíri-yasí",
        "0": "kuá musapíri-yasí",
        "1": "amũ musapíri-yasí",
        "future": {
          "one": "{0} mu-y. resê",
          "other": "{0} mu-y. itá resê"
        },
        "past": {
          "one": "aikué {0} mu-y.",
          "other": "aikué {0} mu-y. itá"
        }
      },
      "second": {
        "0": "kuíri",
        "future": {
          "one": "{0} segũdu resê",
          "other": "{0} segũdu resê itá"
        },
        "past": {
          "one": "aikué {0} segũdu",
          "other": "aikué {0} segũdu itá"
        }
      },
      "second-narrow": {
        "0": "kuíri",
        "future": {
          "one": "{0} seg. resê",
          "other": "{0} seg. resê itá"
        },
        "past": {
          "one": "aikué {0} seg.",
          "other": "aikué {0} seg. itá"
        }
      },
      "second-short": {
        "0": "kuíri",
        "future": {
          "one": "{0} seg. resê",
          "other": "{0} seg. resê itá"
        },
        "past": {
          "one": "aikué {0} seg.",
          "other": "aikué {0} seg. itá"
        }
      },
      "week": {
        "-1": "sẽmãna kuera",
        "0": "kuá sẽmãna",
        "1": "amũ sẽmãna",
        "future": {
          "one": "{0} sẽmãna resê",
          "other": "{0} sẽmãna itá resê"
        },
        "past": {
          "one": "aikué {0} sẽmãna",
          "other": "aikué {0} sẽmãna itá"
        }
      },
      "week-narrow": {
        "-1": "sẽmãna kuera",
        "0": "kuá sẽmãna",
        "1": "amũ sẽmãna",
        "future": {
          "one": "{0} sẽm. resê",
          "other": "{0} sẽm. itá resê"
        },
        "past": {
          "one": "aikué {0} sẽm.",
          "other": "aikué {0} sẽm. itá"
        }
      },
      "week-short": {
        "-1": "sẽmãna kuera",
        "0": "kuá sẽmãna",
        "1": "amũ sẽmãna",
        "future": {
          "one": "{0} sẽm. resê",
          "other": "{0} sẽm. itá resê"
        },
        "past": {
          "one": "aikué {0} sẽm.",
          "other": "aikué {0} sẽm. itá"
        }
      },
      "year": {
        "-1": "akayú kuera",
        "0": "kuá akayú",
        "1": "amũ akayú",
        "future": {
          "one": "{0} akayú resê",
          "other": "{0} akayú itá resê"
        },
        "past": {
          "one": "aikué {0} akayú",
          "other": "aikué {0} akayú itá"
        }
      },
      "year-narrow": {
        "-1": "akayú kuera",
        "0": "kuá akayú",
        "1": "amũ akayú",
        "future": {
          "one": "{0} akayú resê",
          "other": "{0} akayú itá resê"
        },
        "past": {
          "one": "aikué {0} akayú",
          "other": "aikué {0} akayú itá"
        }
      },
      "year-short": {
        "-1": "akayú kuera",
        "0": "kuá akayú",
        "1": "amũ akayú",
        "future": {
          "one": "{0} akayú resê",
          "other": "{0} akayú itá resê"
        },
        "past": {
          "one": "aikué {0} akayú",
          "other": "aikué {0} akayú itá"
        }
      }
    },
    "locale": "yrl-CO"
  });
}